import styled from 'styled-components';

export const HorizontalLine = styled.hr<{ $color?: string, $margin?: string, $height?: string, $width?: string, $minWidth?: string }>`
    width: ${({ $width }) => $width ?? '100%'};
    height: ${({ $height }) => $height ?? '1px'};
    border-width: 0px;
    background-color: ${({ $color, theme: { mobileAppAccelerator: { semanticColors } } }) => ($color ? $color : semanticColors.grayVariant5)};;
    margin: ${({ $margin }) => $margin};
    min-width: ${({ $minWidth }) => $minWidth ?? 'unset'};
`;
